module.exports = __webpack_public_path__ + "img/B@2x.eb25817e.jpg";